export default __webpack_public_path__ + "static/media/section1-img2.89eab7f3.png";